import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select } from "antd";
import { connect } from "react-redux";
import { requestServerPost } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const formTailLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18, offset: 6 },
};

const EditImageVideoMediaView = (props) => {
  const [form] = Form.useForm();
  const [accessBranches, setAccessBranches] = useState(["all"]);
  const {
    requestServerPost,
    usertoken,
    data,
    branches = [],
    onSuccess,
  } = props;
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).editMedia;

  useEffect(() => {
    if (data) {
      form.setFieldsValue({ medianame: data.FileName });

      const ab = data.AccessBranches;
      if (ab && ab !== "null" && ab !== "all" && ab !== "") {
        setAccessBranches(
          ab
            .split(",")
            .map((id) => String(id).trim())
            .filter(Boolean),
        );
      } else {
        setAccessBranches(["all"]);
      }
    }
  }, []);

  const handleAccessBranchesChange = (value) => {
    let newVal;
    if (value.includes("all") && !accessBranches.includes("all")) {
      newVal = ["all"];
    } else if (accessBranches.includes("all") && value.length > 1) {
      newVal = value.filter((v) => v !== "all");
    } else if (value.length === 0) {
      newVal = ["all"];
    } else {
      newVal = value;
    }
    setAccessBranches(newVal);
  };

  const onFinish = (values) => {
    const params = {
      fileid: data.FileID,
      filename: values.medianame,
      accessbranches: accessBranches.includes("all")
        ? "all"
        : accessBranches.join(","),
    };

    requestServerPost(
      "update_file",
      params,
      {},
      (response) => {
        PopupManager.closePopup();
        if (onSuccess) onSuccess();
      },
      usertoken,
    );
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      name="edit_image_video"
      style={{ width: "100%" }}
    >
      <Form.Item
        {...formItemLayout}
        name="medianame"
        label={t.fieldName}
        rules={[{ required: true, message: t.fieldNameRequired }]}
      >
        <Input placeholder={t.fieldNamePlaceholder} />
      </Form.Item>

      {branches.length > 0 && (
        <Form.Item {...formItemLayout} label={t.accessibleBranches}>
          <Select
            allowClear
            mode="multiple"
            style={{
              width: "100%",
              border: "1.5px solid #ccc",
              borderRadius: "5px",
              overflow: "hidden",
            }}
            value={accessBranches}
            onChange={handleAccessBranchesChange}
            maxTagCount="responsive"
          >
            <Option key="all" value="all">
              {t.allBranches}
            </Option>
            {branches.map((b) => (
              <Option key={b.BranchID} value={String(b.BranchID)}>
                {b.BranchName}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item {...formTailLayout}>
        <Button type="primary" htmlType="submit">
          {t.save}
        </Button>
      </Form.Item>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  usertoken: state.usertoken,
});

export default connect(mapStateToProps, { requestServerPost })(
  EditImageVideoMediaView,
);
